import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { useMultiTierCheckout } from '../../../context';
import { StepProps, StepsId } from '../../../types';
import AuthenticationFlow from 'legacy/auth/components/authentication-flow/AuthenticationFlow';
import useAuthenticationStatus from 'legacy/common/hooks/useAuthenticationStatus';

import styles from '../../../../Checkout.module.scss';

type Props = Pick<StepProps, 'goToStep'>;

const ConfirmButton = ({ goToStep }: Props) => {
  const { isAuthenticated } = useAuthenticationStatus();
  const {
    data: {
      waivers,
      checkoutSession: {
        checkoutError,
        confirmCheckout,
        isLoadingCheckout,
        checkoutSession
      }
    },
    onSuccess,
    onAuthenticationSuccess
  } = useMultiTierCheckout();

  const isTicketBasketEmpty =
    Object.keys(checkoutSession?.ticketBasket || {}).length === 0;

  // Block the user from submitting if
  // - Checkout is busy.
  // - User has selected paid tickets AND checkout session has not been assigned a card yet.
  const isDisabled =
    isLoadingCheckout ||
    (checkoutSession?.total > 0 && !checkoutSession?.card) ||
    isTicketBasketEmpty;

  const onConfirm = () => {
    if (waivers.data.length > 0) {
      goToStep(StepsId.WaiversStep);
    } else {
      confirmCheckout({ allWaiversAccepted: waivers.allWaiversAccepted }).then(
        () => {
          onSuccess();
          goToStep(StepsId.SuccessStep);
        }
      );
    }
  };

  const getButtonText = () => {
    if (waivers.data.length > 0) {
      return 'Continue to waivers';
    }
    if (checkoutSession?.total === 0) {
      return 'Confirm & RSVP';
    }
    return 'Confirm & Pay';
  };

  const buttonText = getButtonText();

  if (!isAuthenticated()) {
    return (
      <AuthenticationFlow onCompleteAuthentication={onAuthenticationSuccess}>
        {({ startAuthenticationFlow }) => (
          <div className={styles.nextButtonWrapperMulti}>
            <Button onClick={startAuthenticationFlow} type={ButtonType.Primary}>
              Continue
            </Button>
          </div>
        )}
      </AuthenticationFlow>
    );
  }

  return (
    <div className={styles.nextButtonWrapperMulti}>
      {checkoutError?.message && (
        <div className="text-error text-center pb-2 max-h-[60px] overflow-y-auto">
          {checkoutError.message}
        </div>
      )}
      <Button
        onClick={onConfirm}
        type={ButtonType.Primary}
        loading={isLoadingCheckout}
        disabled={isDisabled}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default ConfirmButton;
